var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-3", attrs: { role: "main", id: "instructions" } },
    [
      _vm.isPlaceOpen
        ? _c("h1", [
            _vm._v(_vm._s(_vm.$t("AidApplication.AidType.C_PlaceOpen")))
          ])
        : _vm.isAkC
        ? _c("h1", [
            _vm._v(
              _vm._s(_vm.$t("AidApplication.AidType.Ak")) +
                " (Ak) / " +
                _vm._s(_vm.$t("AidApplication.AidType.C")) +
                " (C)"
            )
          ])
        : _vm.isAy
        ? _c("h1", [
            _vm._v(_vm._s(_vm.$t("AidApplication.AidType.Ay")) + " (Ay)")
          ])
        : _vm.isICT
        ? _c("h1", [
            _vm._v(
              _vm._s(_vm.$t("AidApplication.AidType.B")) +
                " (B) / " +
                _vm._s(_vm.$t("Enums.BOptions.41"))
            )
          ])
        : _vm.isPremises
        ? _c("h1", [
            _vm._v(
              _vm._s(_vm.$t("AidApplication.AidType.B")) +
                " (B) / " +
                _vm._s(_vm.$t("Enums.BOptions.42"))
            )
          ])
        : _vm.isSupportApartments
        ? _c("h1", [
            _vm._v(
              _vm._s(_vm.$t("AidApplication.AidType.B")) +
                " (B) / " +
                _vm._s(_vm.$t("Enums.BOptions.43"))
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        domProps: {
          innerHTML: _vm._s(_vm.$t("Instructions.TechnicalInstructions"))
        }
      }),
      _vm._v(" "),
      _c("h2", [
        _vm._v("1. " + _vm._s(_vm.$t("AidApplication.Menu.BasicInfo")))
      ]),
      _vm._v(" "),
      _vm.isPlaceOpen
        ? _c("basic-info-place-open-instructions")
        : _vm.isB
        ? _c("basic-info-investment-instructions")
        : _c("basic-info-instructions"),
      _vm._v(" "),
      _c("h2", [
        _vm._v("2. " + _vm._s(_vm.$t("AidApplication.Menu.Operation")))
      ]),
      _vm._v(" "),
      _vm.isPlaceOpen
        ? _c("operation-place-open-instructions")
        : _vm.isB
        ? _c("operation-investment-instructions")
        : _c("operation-instructions"),
      _vm._v(" "),
      !_vm.isPlaceOpen
        ? _c("h2", [
            _vm._v("3. " + _vm._s(_vm.$t("AidApplication.Menu.Partners")))
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isPlaceOpen ? _c("partner-instructions") : _vm._e(),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          _vm._s(_vm.isPlaceOpen ? "3." : "4.") +
            " " +
            _vm._s(_vm.$t("AidApplication.Menu.BudgetaryEstimate"))
        )
      ]),
      _vm._v(" "),
      _vm.isICT
        ? _c("budgetary-estimate-ict-instructions")
        : _vm.isPremises
        ? _c("budgetary-estimate-premises-instructions")
        : _vm.isSupportApartments
        ? _c("budgetary-estimate-support-apartments-instructions")
        : _c("budgetary-estimate-instructions")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }